import React from 'react'
import {
  Container,
  Sticky,
  TextBody,
  Link,
  Image
} from '@pmi/pmi-iqos-ds-react'
import {
  htmlTranslation,
  localstorage,
  Price
} from '@pmi/pmi-iqos-shared-react'
import { AddToCartButton, CartIcon64 } from '@dcx-common/components'
const ProductDetailBar = ({
  product,
  options,
  selectedOptionIndex,
  loading,
  onAddToCart,
  onAddToPreorder,
  onVariantNameClick,
  translations,
  line
}) => {
  const displayProductName = mobile => (
    <TextBody
      size={mobile ? TextBody.sizes.s : TextBody.sizes.l}
      breakWords
      data-testing="ProductDetail_TextBody_ProductName"
      {...(product.name
        ? { value: product.name }
        : htmlTranslation(translations, 'tk_productName'))}
    />
  )
  const cartCounter = localstorage.get('reactCartCounter')

  const selectedOption = options && options[selectedOptionIndex]
  if (selectedOption) {
    const { price, stock, images, listPrice } = selectedOption

    return (
      <Sticky
        zIndex="10"
        fullWidth
        followNavBar={true}
        l="0"
        t={['auto', 'auto', '0']}
        b={['0', '0', 'auto']}>
        <Container
          display={Container.displays.flex}
          flexDirection={Container.flexDirections.row}
          justifyContent={[
            Container.justifyContentValues.center,
            Container.justifyContentValues.between
          ]}
          bg={Container.backgrounds.white}
          fullWidth
          py={['2', '2', '3']}
          px={[line ? '6' : '2', '2', '8']}
          divider={[
            Container.dividers.top,
            Container.dividers.top,
            Container.dividers.bottom
          ]}>
          {!line ? (
            <Container
              display={Container.displays.flex}
              flexDirection={Container.flexDirections.row}
              alignItems={Container.alignItemsValues.center}>
              <Image
                src={images[0] && images[0].path}
                alt={images[0] && images[0].alt}
                height={['16', '16', '16']}
              />
              <Container
                pl={['0', '0', '4']}
                pr={['1', '1', '0']}
                display={Container.displays.flex}
                flexDirection={[
                  Container.flexDirections.column,
                  Container.flexDirections.column,
                  Container.flexDirections.row
                ]}
                alignItems={[null, null, Container.alignItemsValues.center]}
                onClickHandler={onVariantNameClick}>
                <Container
                  display={[
                    Container.displays.block,
                    Container.displays.block,
                    Container.displays.none
                  ]}>
                  {displayProductName(true)}
                </Container>
                <Container
                  display={[
                    Container.displays.none,
                    Container.displays.none,
                    Container.displays.block
                  ]}>
                  {displayProductName(false)}
                </Container>
                <Container
                  pl="4"
                  display={[
                    Container.displays.none,
                    Container.displays.none,
                    Container.displays.block
                  ]}>
                  <Link
                    href={'javascript:void(0)'}
                    newTab={false}
                    data-testing="ProductDetail_Link_ShortVariantName">
                    <TextBody size={TextBody.sizes.xs} ellipsis>
                      {selectedOption.shortVariantName}
                    </TextBody>
                  </Link>
                </Container>
              </Container>
            </Container>
          ) : null}
          <Container
            display={Container.displays.flex}
            justifyContent={[
              Container.justifyContentValues.center,
              Container.justifyContentValues.end
            ]}
            alignItems={Container.alignItemsValues.center}
            pl={['0', '4']}
            px={line ? '4' : null}>
            <Container
              pr="8"
              display={[
                Container.displays.none,
                Container.displays.none,
                Container.displays.block
              ]}>
              <Price
                size={Price.sizes.large}
                listPrice={listPrice}
                price={price}
                currency={product.currency}
                listPriceLabel={translations.tk_listPriceDescription}
                discountedPriceLabel={
                  translations.tk_discountedPriceDescription
                }
                taxLabel={translations.tk_withTax}
                data-testing="ProductDetail_ProductDetailBar_Price"
              />
            </Container>

            <AddToCartButton
              fullWidth={!!line}
              maxQty={product.maxQty}
              hasStock={!!stock}
              addToCartHandler={onAddToCart}
              addToPreorderHandler={onAddToPreorder}
              loading={loading}
              addToCartLabel={translations.tk_buttonAddToCart}
              addToPreorderLabel={translations.tk_buttonAddToPreorder}
              addToPreorderLabelDisabled={
                translations.tk_buttonAddToPreorderDisabled
              }
              outOfStockAction={product.outOfStockAction}
              data-testing="ProductDetail_ProductDetailBar_Button_AddToCart"
            />
            {line ? (
              <Container pl="4">
                <CartIcon64 hasItems={cartCounter && cartCounter.counter > 0} />
              </Container>
            ) : null}
          </Container>
        </Container>
      </Sticky>
    )
  }

  return null
}

export default ProductDetailBar
